<div class="container" [ngClass]="{ 'p-0 m-0': isModal }" style="position: relative;">
  @if (isPreselectingCheckboxes) {
    <div class="preselect-overlay">
      <mat-progress-spinner diameter="36" mode="indeterminate" class="mat-spinner-color"></mat-progress-spinner>
      <span class="preselect-overlay__label">Applying selections...</span>
    </div>
  }
  <custom-table
    #tableRef
    [tableData]="dataSource"
    [tableColumns]="tableColumns"
    [tableTitle]="'Candidates'"
    [tableActions]="tableActions"
    [tableTitle]="title"
    [moduleType]="'operations'"
    [pageType]="'candidates'"
    hideTableTitle="true"
    (tableActionEmitter)="tableAction($event)"
    [handleToggleInParent]="handleToggleInParent"
    (toogleEmitter)="toggleEmitterEvent($event.row, $event.checked)"
    (rowAction)="rowAction($event)"
    [onlyDefaultColumns]="true"
    [showBreadcrumb]="false"
    [isFilterable]="false"
    isFilterPresent="true"
    isdatePicker="true"
    [filterAttributes]="filterAttributes"
    [dateRangeDetails]="dateRangeDetails"
    [radioButtonCallBack]="radioButtonCallBack"
    [selectedItems]="selectedItems"
    [enablePreSelection]="true"
    (selectedItemsChange)="selectedItemsChange.emit($event)"
    [totalCount]="totalCount"
    [serverSidePagination]="serverSidePagination"
    [paginationSizes]="paginationSizes"
    (page)="page.emit($event)"
    (allTextSearch)="allTextSearch.emit($event)"
    >
  </custom-table>
</div>
